import type { HeroItem } from "../model/landing.types";

export const HERO_ITEMS: HeroItem[] = [
  {
    headline: "What's on your mind?",
    subheadline: "Join us on a journey to mindfulness and tranquility.",
    ctaLabel: "Click here! Share your mood with us! Let's go...",
  },
];
